export const FormLabelClass = "text-gray-500 text-sm"; //pt-4
export const TitleLabelClass = "stdlib-h1" //text-gray-400 text-xl

export const PlaceholderClass = "text-gray-500"